import { Select } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useAuthStore } from '@/store/auth';
import { setupApi } from '@/api/setup';

export function YearPicker() {
  const academicYearId = useAuthStore((s) => s.academicYearId);
  const setAcademicYear = useAuthStore((s) => s.setAcademicYear);

  const { data: years, isLoading } = useQuery({
    queryKey: ['academic-years'],
    queryFn: () => setupApi.listAcademicYears(),
    staleTime: 5 * 60_000,
  });

  // Seed the picker with the current year on first load if nothing is selected.
  useEffect(() => {
    if (!years || academicYearId != null) return;
    const current = years.find((y) => y.current) ?? years[0];
    if (current) setAcademicYear(current.id);
  }, [years, academicYearId, setAcademicYear]);

  return (
    <Select
      variant="filled"
      loading={isLoading}
      value={academicYearId ?? undefined}
      onChange={(v) => setAcademicYear(v)}
      suffixIcon={<CalendarOutlined />}
      style={{ width: 140 }}
      placeholder="Select year"
      options={(years ?? []).map((y) => ({
        value: y.id,
        label: y.current ? `${y.name} · current` : y.name,
      }))}
    />
  );
}
